export default "__VITE_ASSET__bf478ce9__"